var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TarjetaDatos',{attrs:{"titulo":_vm.titulo,"tipo":"naranja"}},[_vm._v(" Póliza mediada. Póngase en contacto con INTERNAUTO ")])}
var staticRenderFns = []

export { render, staticRenderFns }